import React, { useEffect, useState } from "react";
import { Spin, message } from "antd";
import { useSelector } from "react-redux";
import axiosInstance from "../../utils/axiosInstance";
import ClauseTemplateHeader from "../../components/clause/ClauseTemplateHeader";
import ClauseFormModal from "../../components/clause/ClauseFormModal";
import ClauseTable from "../../components/clause/ClauseTable";

export default function ClauseTemplate() {
  const userRole = useSelector((state) => state.auth.userInfo.role);
  const comp_id = useSelector((state) => state.auth.userInfo.company_id);
  const compnayId = localStorage.getItem("companyId") || comp_id;

  const [clauseData, setClauseData] = useState([]);
  const [masterClausesData, setMasterClausesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSaveAsModalOpen, setIsSaveAsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const fetchClauses = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/clause/?company_id=${compnayId}`);
      setClauseData(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const fetchMasterClauses = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/get-master-clause/`);
      setMasterClausesData(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchClauses();
    fetchMasterClauses();
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await axiosInstance.delete(`/contract/clause/`, {
        customParams: { clause_id: id, company_id: compnayId },
      });
      if (response.status === 200) {
        message.success(response.data.message);
        fetchClauses();
        fetchMasterClauses();
      } else {
        message.error(response.data.message);
      }
    } catch (err) { }
  };

  const handleSaveAs = (record) => {
    setSelectedRecord({
      ...record,
      master_clause_id: record.id,
    });
    setIsSaveAsModalOpen(true);
  };

  const isUserMasterAllowed = [
    "agreement controller team",
    "agreement controller head",
    "professional agreement controller team",
    "professional agreement controller head",
    "professional",
  ].includes(userRole);

  return (
    <>
      <ClauseTemplateHeader onAdd={() => setIsModalOpen(true)} />

      <Spin spinning={isLoading} tip="Loading...">
        <ClauseTable
          data={clauseData}
          onDelete={handleDelete}
          isMaster={false}
        />
      </Spin>

      {isUserMasterAllowed && (
        <>
          <h1 className="font-semibold text-[15px] dark:text-white">
            Master Clauses
          </h1>
          <Spin spinning={isLoading} tip="Loading...">
            <ClauseTable
              data={masterClausesData}
              onSaveAs={handleSaveAs}
              isMaster={true}
            />
          </Spin>
        </>
      )}

      <ClauseFormModal
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSuccess={() => {
          fetchClauses();
          setIsModalOpen(false);
        }}
        companyId={compnayId}
      />

      <ClauseFormModal
        visible={isSaveAsModalOpen}
        onCancel={() => {
          setIsSaveAsModalOpen(false);
          setSelectedRecord(null);
        }}
        onSuccess={() => {
          fetchClauses();
          fetchMasterClauses();
          setIsSaveAsModalOpen(false);
        }}
        isSaveAs={true}
        recordData={selectedRecord}
      />
    </>
  );
}



// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Space,
//   Button,
//   Spin,
//   Modal,
//   Form,
//   Input,
//   Row,
//   Col,
//   message,
//   Tooltip,
// } from "antd";
// import { convertIntoFormData, handlePdfDownload } from "../../utils/utils";
// import { limitWords } from "../../utils/utils";
// import axiosInstance from "../../utils/axiosInstance";
// import { useSelector } from "react-redux";
// import MotionIconButton from "../../components/icons/MotionIcon";
// import DownloadOutlinedIcon from "../../components/icons/DownloadOutlineIcon";
// import SaveOutlinedIcon from "../../components/icons/SaveOutlinedIcon";
// import DeleteOutlinedIcon from "../../components/icons/DeleteOutlineIcon";
// function ClauseTemplate() {
//   const [form] = Form.useForm();
//   const [clauseData, setClauseData] = useState([]);
//   const [masterClauesData, setMasterClauesData] = useState([]);

//   const [isLoading, setIsLoading] = useState(false);
//   const [isFormLoading, setIsFormLoading] = useState(false);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isSaveAsModal, setIsSaveAsModal] = useState(false);
//   const [recordData, setRecordData] = useState(null); // State to hold record data

//   const [fileName, setFilename] = useState();
//   const userRole = useSelector((state) => state.auth.userInfo.role);
//   const comp_id = useSelector((state) => state.auth.userInfo.company_id);
//   const compnayId = localStorage.getItem("companyId") || comp_id;

//   const showModal = () => {
//     setIsModalOpen(true);
//   };
//   const updateRecordData = (
//     clauseName,
//     description,
//     serialNumber,
//     implementationInstances,
//     masterClauseid
//   ) => {
//     setRecordData({
//       clause_name: clauseName,
//       description: description,
//       serial_number: serialNumber,
//       implementation_instances: implementationInstances,
//       master_clause_id: masterClauseid,
//     });

//     setIsSaveAsModal(true);
//   };
//   const clickSaveAs = () => {
//     setIsSaveAsModal(true);
//   };

//   const handleOk = async () => {
//     try {
//       await form.validateFields();
//       const values = await form.getFieldsValue();
//       setIsFormLoading(true);
//       const fromData = convertIntoFormData({ ...values, clause_file: fileName && fileName, company_id: compnayId });
//       const response = await axiosInstance.post(`/contract/clause/`, fromData);
//       if (response.status === 200) {
//         message.success(response.data.message);
//         fetchClauses();
//         setIsModalOpen(false);
//         setIsFormLoading(false);
//         form.resetFields();
//       } else {
//         message.error(response.data.message);
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       setIsModalOpen(false);
//       form.resetFields();
//     }
//   };
//   const handleSaveAsOk = async () => {
//     await form.validateFields();
//     const values = await form.getFieldsValue();
//     try {
//       setIsFormLoading(true);
//       const fromData = convertIntoFormData({
//         ...values,
//         master_clause_id: recordData?.master_clause_id || "",
//       });
//       const response = await axiosInstance.post(`/contract/save-as-clause/`, fromData);

//       if (response.status === 200) {
//         message.success(response.data.message);
//         fetchClauses();
//         fetchMasterClause();
//         setIsSaveAsModal(false);
//         form.resetFields();
//       } else {
//         message.error(response.data.message || "Something went wrong");
//         setIsSaveAsModal(false);
//       }
//     } catch (error) {
//       console.error("Error:", JSON.stringify(error, null, 2)); // proper log
//       message.error(error?.response?.data?.message || "Error saving clause");
//       setIsSaveAsModal(false);
//       form.resetFields();
//     }

//   };

//   const onCancel = () => {
//     setIsModalOpen(false);
//     setIsFormLoading(false);
//     setIsSaveAsModal(false);
//     setRecordData(null);
//     form.resetFields();
//   };

//   const fetchClauses = async () => {
//     try {
//       setIsLoading(true);
//       const response = await axiosInstance.get(`/contract/clause/?company_id=${compnayId}`);
//       console.log(response.data, "clauses");
//       setIsLoading(false);
//       setClauseData(response.data);
//     } catch (error) {
//       setIsLoading(false);
//     }
//   };
//   const fetchMasterClause = async () => {
//     try {
//       setIsLoading(true);
//       const response = await axiosInstance.get(`/contract/get-master-clause/`);
//       setIsLoading(false);
//       setMasterClauesData(response.data);
//     } catch (error) {
//       setIsLoading(false);
//     }
//   };
//   useEffect(() => {
//     fetchClauses();
//     fetchMasterClause();
//   }, []);

//   const handleDelete = async (id) => {
//     try {
//       const response = await axiosInstance.delete(`/contract/clause/`, {
//         customParams: {
//           clause_id: id,
//           company_id: compnayId,
//         }
//       });

//       if (response.status === 200) {
//         message.success(response.data.message);
//         fetchClauses();
//         fetchMasterClause();
//       } else {
//         message.error(response.data.message);
//       }
//     } catch (err) { }
//   };
//   const clauseColumns = [
//     {
//       title: "Created By",
//       dataIndex: "created_by",
//       render: (text, record) => (
//         <Tooltip title={text}>
//           <div
//             style={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {limitWords(text, 6)}
//           </div>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Clause name",
//       dataIndex: "clause_name",
//       render: (text, record) => (
//         <Tooltip title={text}>
//           <div
//             style={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {limitWords(text, 6)}
//           </div>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Implementation Instances",
//       dataIndex: "implementation_instances",
//       render: (text, record) => (
//         <Tooltip title={text}>
//           <div
//             style={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {limitWords(text, 6)}
//           </div>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       render: (text, record) => (
//         <Tooltip title={text}>
//           <div
//             style={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {limitWords(text, 6)}
//           </div>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Download",
//       dataIndex: "clause_file",
//       render: (_, record) => (
//         <Space>
//           <div
//             // type="primary"
//             onClick={() => handlePdfDownload(record.clause_file)}
//           >
//             <DownloadOutlinedIcon />
//           </div>
//         </Space>
//       ),
//     },
//     {
//       title: "Delete",
//       dataIndex: "template_file",
//       render: (_, record) => (
//         <Space>
//           <div onClick={() => handleDelete(record.id)}>
//             <DeleteOutlinedIcon />
//           </div>
//         </Space>
//       ),
//     },
//   ];
//   const masterClauseColumns = [
//     {
//       title: "Created By",
//       dataIndex: "created_by",
//       render: (text, record) => (
//         <Tooltip title={text}>
//           <div
//             style={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {limitWords(text, 6)}
//           </div>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Clause name",
//       dataIndex: "clause_name",
//       render: (text, record) => (
//         <Tooltip title={text}>
//           <div
//             style={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {limitWords(text, 6)}
//           </div>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Implementation Instances",
//       dataIndex: "implementation_instances",
//       render: (text, record) => (
//         <Tooltip title={text}>
//           <div
//             style={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {limitWords(text, 20)}
//           </div>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       render: (text, record) => (
//         <Tooltip title={text}>
//           <div
//             style={{
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {limitWords(text, 6)}
//           </div>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Download",
//       dataIndex: "clause_file",
//       render: (_, record) => (
//         <Space>
//           <div
//             // type="primary"
//             onClick={() => handlePdfDownload(record.clause_file)}
//           >
//             <DownloadOutlinedIcon />
//           </div>
//         </Space>
//       ),
//     },
//     {
//       title: "Save As",
//       dataIndex: "id",
//       render: (_, record) => (
//         <Space>
//           <div
//             // type="primary"
//             onClick={() => {
//               console.log("records", record);
//               updateRecordData(
//                 record.clause_name,
//                 record.description,
//                 record.serial_number,
//                 record.implementation_instances,
//                 record.id
//               );
//               // setRecordData({
//               //   clause_name: record.clause_name,
//               //   description: record.description,
//               //   serial_number: record.serial_number,
//               //   master_clause_id: record.id,
//               // });
//               clickSaveAs();
//             }}
//           >
//             <SaveOutlinedIcon />
//           </div>
//         </Space>
//       ),
//     },
//   ];
//   console.log(clauseData)

//   return (
//     <>
//       <div className=" text-black pb-3 h-[60px] flex items-center justify-between">
//         <span>
//           <h1 className="font-semibold text-[15px] dark:text-white">Clauses</h1>
//         </span>
//         <>
//           <MotionIconButton tooltip="Add Clauses" onClick={showModal} />
//           <Modal
//             open={isModalOpen}
//             title="Add Clause"
//             onCancel={onCancel}
//             footer={[
//               <Button key="cancel" onClick={onCancel}>
//                 Cancel
//               </Button>,
//               <Button
//                 key="submit"
//                 type="primary"
//                 onClick={handleOk}
//                 loading={isFormLoading}
//               >
//                 Submit
//               </Button>,
//             ]}
//           >
//             <Form form={form} layout="vertical">
//               <Row gutter={16}>
//                 <Col span={12}>
//                   <Form.Item
//                     label="Clause Name"
//                     name="clause_name"
//                     rules={[
//                       {
//                         required: true,
//                         message: "This field is required!",
//                       },
//                     ]}
//                   >
//                     <Input placeholder="Enter Clause  Name" />
//                   </Form.Item>
//                 </Col>
//                 <Col span={12}>
//                   <Form.Item
//                     label="Implementation Instances"
//                     name="implementation_instances"
//                     rules={[
//                       {
//                         required: true,
//                         message: "This field is required!",
//                       },
//                     ]}
//                   >
//                     <Input placeholder="Enter Implementation Instances" />
//                   </Form.Item>
//                 </Col>
//                 <Col span={12}>
//                   <Form.Item
//                     label="Description"
//                     name="description"
//                     rules={[
//                       {
//                         required: true,
//                         message: "This field is required!",
//                       },
//                     ]}
//                   >
//                     <Input placeholder="Enter Description" />
//                   </Form.Item>
//                 </Col>

//                 <Col span={12}>
//                   <Form.Item
//                     label="Select File"
//                     name="clause_file"
//                     valuePropName="fileList"
//                     getValueFromEvent={(e) => {
//                       return e.target.files;
//                     }}
//                     className="mr-2 attachment-input"
//                     rules={[
//                       {
//                         required: true,
//                         message: "This field is required",
//                       },
//                     ]}
//                   >
//                     <Input
//                       type="file"
//                       accept=".doc, .docx"
//                       onChange={(e) => setFilename(e.target.files[0])}
//                       className="form-control"
//                     />
//                   </Form.Item>
//                 </Col>
//               </Row>
//             </Form>
//           </Modal>
//           <Modal
//             title="Save Clause As"
//             open={isSaveAsModal}
//             onOk={handleSaveAsOk}
//             onCancel={onCancel}
//             style={{ fontSize: "24px", padding: "40px" }}
//             okText="Save"
//             okButtonProps={{
//               style: {
//                 backgroundColor: "#4E36A3",
//                 color: "white",
//                 height: "40px",
//                 width: "100px",
//               },
//               disabled: isLoading,
//             }}
//             cancelButtonProps={{
//               style: {
//                 backgroundColor: "",
//                 color: "#4E36A3",
//                 height: "40px",
//                 width: "100px",
//               },
//             }}
//           >
//             <Form form={form}>
//               <Col>Clause Name</Col>
//               <Form.Item
//                 label=""
//                 name="clause_name"
//                 initialValue={recordData && recordData.clause_name}
//               >
//                 <Input
//                   placeholder=""
//                   defaultValue={recordData && recordData?.clause_name}
//                 />
//               </Form.Item>
//               <Col>Description</Col>

//               <Form.Item
//                 label=""
//                 name="description"
//                 initialValue={recordData?.description}
//               >
//                 <Input placeholder="" defaultValue={recordData?.description} />
//               </Form.Item>
//               <Col>Serial Number</Col>
//               <Form.Item
//                 label=""
//                 name="serial_number"
//                 initialValue={recordData?.serial_number}
//               >
//                 <Input
//                   placeholder=""
//                   defaultValue={recordData?.serial_number}
//                 />
//               </Form.Item>
//               <Col>Implementation Instances</Col>
//               <Form.Item
//                 label=""
//                 name="implementation_instances"
//                 initialValue={recordData?.implementation_instances}
//               >
//                 <Input
//                   placeholder=""
//                   defaultValue={recordData?.implementation_instances}
//                 />
//               </Form.Item>
//             </Form>
//           </Modal>
//         </>
//       </div>
//       <Spin spinning={isLoading} tip="Loading...">
//         <Table
//           dataSource={clauseData && clauseData}
//           columns={clauseColumns}
//           pagination={true}
//           bordered
//           size="small"
//           className="mb-4 template-table text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
//           scroll={{ x: "max-content" }}
//         />
//       </Spin>
//       {(userRole === "agreement controller team" || userRole === "agreement controller head" || userRole === "professional agreement controller team" || userRole === "professional agreement controller head" || userRole === "professional") && (
//         <>
//           <span>
//             <h1 className="font-semibold text-[15px] dark:text-white">
//               Master Clauses
//             </h1>
//           </span>
//           <Spin spinning={isLoading} tip="Loading...">
//             <Table
//               dataSource={masterClauesData && masterClauesData}
//               columns={masterClauseColumns}
//               pagination={true}
//               bordered
//               size="small"
//               className="mb-4 template-table text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
//               scroll={{ x: "max-content" }}
//             />
//           </Spin>
//         </>
//       )}
//     </>
//   );
// }

// export default ClauseTemplate;
